import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../../index.css";

const API_URL = "https://backend.aktcorp.com/media";

const NewsSlider = () => {
  const [newsData, setNewsData] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  /*const token = localStorage.getItem("authToken");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };*/

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(API_URL);
        const data = response.data.data;
        setNewsData(data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
  }, []);

  useEffect(() => {
    if (swiperInstance && newsData.length > 0) {
      setTimeout(() => {
        swiperInstance.update();
        swiperInstance.slideTo(0, 0);
        swiperInstance.autoplay?.start();
      }, 500);
    }
  }, [swiperInstance, newsData]);

  return (
    <div className="w-full mx-auto py-0 px-4">
      <Swiper
        onSwiper={(swiper) => setSwiperInstance(swiper)}
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        loop={newsData.length >= 5} // ✅ only enable loop if 5 or more items
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true, el: ".custom-pagination" }}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        className="rounded-lg"
      >
        {newsData.map((news) => (
          <SwiperSlide key={news.id} className="flex h-full">
            <div className="bg-white rounded-lg overflow-hidden p-3 h-full flex flex-col justify-between">
              <div className="overflow-hidden rounded-md">
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-[260px] object-cover rounded-md hover:scale-110 transition-transform"
                />
              </div>
              <div className="flex-grow">
                <h3 className="text-xl font-semibold mt-4 line-clamp-2">{news.title}</h3>
                <p className="text-gray-600 text-lg mt-2 line-clamp-3">{news.description}</p>
              </div>
              <button
                onClick={() => setSelectedNews(news)}
                className="bg-blue-600 text-gray-800 px-4 py-2 rounded-md mt-3 hover:bg-blue-700"
              >
                READ MORE
              </button>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="custom-pagination mt-10"></div>

      {selectedNews && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 container">
          <div className="bg-white p-6 rounded-lg max-w-md w-full">
            <h2 className="text-xl font-bold">{selectedNews.title}</h2>
            <img
              src={selectedNews.image}
              alt={selectedNews.title}
              className="w-full h-[260px] object-cover rounded-md mt-3"
            />
            <p className="text-gray-700 mt-3">{selectedNews.description}</p>
            <button
              onClick={() => setSelectedNews(null)}
              className="bg-blue-600 text-gray-800 px-4 py-1 rounded-md mt-3 hover:bg-blue-700 w-full"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsSlider;
